import { useEnvironment } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import React from 'react';

import AvatarInput from '../../../../../../../common/components/AvatarInput';
import { useWidget } from '../../../../../../../contexts/widgets';
import { forwardResizedImage } from '../../../../../../../services/event-handler';
import { ProfileAlignment, ProfileLayout } from '../../../../../../../types';
import styles from './Avatar.scss';

export const Avatar = () => {
  const { isRTL } = useEnvironment();
  const { member, profilePage, computed, handlers } = useWidget();

  const { isProfilePreview, isEditing, editPicture } = profilePage;
  const {
    pictureStyle,
    canEdit,
    profileImageSize,
    profileAlignment,
    showTitle,
  } = computed;
  const { setMemberPicture, setEditPicture } = handlers;

  const handlePhotoChange = forwardResizedImage(setMemberPicture);
  const handlePhotoUpload = forwardResizedImage(setEditPicture);

  const isRightAlignment =
    profileAlignment === ProfileAlignment.Right && !isRTL;
  const isCenterAlignment = profileAlignment === ProfileAlignment.Center;
  const hasTitle = !!member.title && showTitle;

  return (
    <AvatarInput
      className={classNames({
        [styles.profilePhoto]: true,
        [styles.isCenterAlignment]: isCenterAlignment,
        [styles.isRightAlignment]: isRightAlignment,
        [styles.noTitle]: !hasTitle,
      })}
      name={member.name}
      imageType={pictureStyle}
      url={(editPicture && editPicture.file) || member.picture}
      onClick={isEditing ? handlePhotoUpload : handlePhotoChange}
      canUpload={!isProfilePreview && canEdit}
      profileLayout={ProfileLayout.FullWidth}
      imageSize={profileImageSize}
    />
  );
};
